// extracted by mini-css-extract-plugin
export default {"inputForm":"input_inputForm__4JA39","logout":"input_logout__bH611"};